import React from 'react';
import Copy from '../../copy/Copy';

const Disclaimer = () => {
  return (
    <>
      <p
        style={{
          textAlign: 'center',
          fontFamily: 'Inter',
          fontWeight: '400',
          color: '#636363',
          marginTop: '0px',
        }}
      >
        <Copy>disclaimer</Copy>
      </p>
      <a
        target="_blank"
        aria-label="Open terms and conditions in a new window"
        href="https://www.ikeono.com/acceptable-use"
        style={{ marginTop: -10 }}
      >
        <Copy>terms</Copy>
      </a>
    </>
  );
};

export default Disclaimer;
